/*
  Mobile sticky add-to-cart bar.

  Shows itself once the product's main submit button has scrolled up out of
  view, and hides again when that button is back on screen or still below the
  fold. The bar's button submits the existing product form via its form=
  attribute, so cart behavior (drawer/notification) is unchanged.

  This tracks scroll position rather than using IntersectionObserver: the
  visibility rule depends on whether the button sits above or below the
  viewport, and that distinction changes without the intersection ratio ever
  crossing a threshold, so an observer can miss the transition and leave the
  bar stuck on screen.
*/
class FluffberryStickyAtc extends HTMLElement {
  connectedCallback() {
    this.target = document.querySelector(this.dataset.buyButtonsSelector);
    if (!this.target) return;

    this.ticking = false;
    this.onScroll = this.requestUpdate.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });

    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  requestUpdate() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.ticking = false;
      this.update();
    });
  }

  update() {
    // Visible only once the main button has passed above the top of the
    // viewport; hidden while it is on screen or still further down the page.
    const scrolledPast = this.target.getBoundingClientRect().bottom < 0;
    if (this.hidden === scrolledPast) this.hidden = !scrolledPast;
  }
}

if (!customElements.get('fluffberry-sticky-atc')) {
  customElements.define('fluffberry-sticky-atc', FluffberryStickyAtc);
}
